// extracted by css-extract-rspack-plugin
export default {"searchResultsList":"Id7rA","resultsContainer":"K70uj"};